module.exports = __webpack_public_path__ + "static/media/homecare-form-img.0429c592.png";